<template>
    <div v-if="locationsCount > 0">
        <hr>
        <h3>LOCATION PREFERENCE</h3>
        <div class="form-group row no-gutter">
            <div class="col-md-10">
                <div class="form-group row no-gutter">
                    <label for="line1" class="col-sm-6 control-label">Select a preferred location for your brick:</label>
                    <div class="col-sm-6">
                        <select class="form-control" v-model="prefLocation" v-on:change="onChange(prefLocation)">
                            <option value="">-- Please select a location --</option>
                            <option v-for="(loc, locIndex) in locationsList" v-bind:value="locIndex">
                                {{loc}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-md-2 text-center">
                <a class="map-link pointer" v-on:click="showPaverLocations">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="4.4015069007873535 25.49999237060547 191.19700622558594 149.10000610351562" role="img" preserveAspectRatio="xMidYMid meet" style="stroke-width: 0px; width: 50px; height: 50px;">
                        <g>
                            <path d="M47.5 174.3h.1c.3.2.7.3 1.1.3.2 0 .4 0 .6-.1l50.7-13.8 50.7 13.8c.2.1.4.1.6.1.4 0 .7-.1 1.1-.3h.1l42-25.6c.9-.5 1.3-1.6 1-2.6l-23.2-81.6c-.2-.7-.7-1.2-1.4-1.5-.7-.3-1.4-.2-2 .1l-23.1 13c-1.1.6-1.5 2.1-.9 3.2s2 1.5 3.2.9l20.6-11.5 22 77.1-37.4 22.8-8.9-71c-.2-1.3-1.4-2.2-2.6-2-1.3.2-2.2 1.3-2 2.6l8.7 71.2-46.5-12.9v-12.7c0-1.3-.7-2.3-2-2.3s-2 1-2 2.3v12.7l-46.4 12.6L60.4 98c.2-1.3-.8-2.4-2.1-2.6-1.3-.1-2.5.7-2.6 2l-8.9 71-37.3-22.8 21.9-77.1L52 80c1.1.6 2.5.2 3.2-.9.6-1.1.2-2.5-.9-3.2L31.1 63c-.6-.3-1.4-.4-2-.1-.7.3-1.2.8-1.4 1.5L4.5 146c-.3 1 .1 2.1 1 2.6l42 25.7z"></path>
                            <path d="M98.4 134.4c.4.4 1 .6 1.6.6.6 0 1.1-.2 1.6-.6 1.6-1.4 38.1-34.9 38.1-69.3 0-22.2-17.4-39.6-39.6-39.6S60.4 42.8 60.4 65c0 33.9 36.5 67.9 38 69.4zM100 30c19.9 0 35 15 35 35 0 28.4-27.9 57.5-35 64.4C93 122.5 65 93 65 65c0-19.9 15.1-35 35-35z"></path>
                            <path d="M121 65c0-11.6-9.4-21-21-21s-21 9.4-21 21 9.4 21 21 21 21-9.4 21-21zm-21 16.3c-9 0-16.3-7.3-16.3-16.3S91 48.7 100 48.7 116.3 56 116.3 65 109 81.3 100 81.3z"></path>
                        </g>
                    </svg>
                    <p>View Map</p>
                </a>
            </div>
        </div>
        <paver-locations-popup modal-id="paverLocationsPopup">
            <template slot="header">Location Preference Map</template>
            <slot>
                <div class="modal-body">
                    <div class="modal-img-wrap">
                        <img class="img-responsive" alt="map" v-bind:src="locationsMapImage"/>
                    </div>
                </div>
            </slot>
        </paver-locations-popup>
    </div>
</template>

<script type="text/jsx">
    import { Event } from '../../../../../assets/js/components/frontend/event.vue'
    import CampaignConfigurationMixin from '../../../../../assets/js/components/frontend/mixin/campaign-configuration.vue'
    import PaverLocationsPopup from '@/components/popup/paver-locations-popup.vue';
    export default {
        name: 'preferred-location',
        mixins: [
            CampaignConfigurationMixin,
        ],
        data: function () {
            return this.getDefaultData();
        },
        props: {
            options: {
                // data source
                type: Object,
                required: true
            },
            location: {
                // initial value is provided via property
                type: String,
                required: true
            },
            onLocationChange: {
                // handler name to inform about change of preferred location
                type: String,
                default: function () {
                    return 'onLocationChange';
                }
            }
        },
        components: {
            'paver-locations-popup': PaverLocationsPopup
        },
        methods: {
            getDefaultData: function () {
                return {
                    prefLocation: this.location
                };
            },
            showPaverLocations: function () {
                Event.$emit('paverLocationsPopup');
            },
            onChange: function (newValue) {
                Event.$emit(this.onLocationChange, newValue);
            }
        },
        computed: {
            campaign: function () {
                return this.$store.state.campaign
            },
            locationsMapImage: function () {
                var res = "images/1x1.png";
                if (this.isLocationPreferenceAllowed) {
                    if ("short_url" in this.campaign && "location_preference" in this.options) {
                        if ("image" in this.options.location_preference) {
                            res = "images/catalog/" + this.campaign.short_url +
                            "/" + this.options.location_preference.image;
                        }
                    }
                }
                return res;
            },
            locationsList: function () {
                var res = {};
                if (this.isLocationPreferenceAllowed) {
                    if ("location_preference" in this.options) {
                        if ("locations" in this.options.location_preference) {
                            res = this.options.location_preference.locations;
                        }
                    }
                }
                return res;
            },
            locationsCount: function () {
                return Object.keys(this.locationsList).length;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// preferred-location.vue?326cfa42